(function () {
  if (window.__TeamK9CopyLockLoaded) return;
  window.__TeamK9CopyLockLoaded = true;

  var config = window.TeamK9CopyLockConfig || {};
  var disabledValues = { "0": true, "off": true, "false": true, "disable": true, "disabled": true };
  var scopeSelector = ".tk9-copy-lock-scope";
  var editableSelector = [
    "input",
    "textarea",
    "select",
    "option",
    "[contenteditable='true']",
    "[data-tk9-copy-allow]"
  ].join(",");
  var defaultTargets = [
    "#MainContent",
    "main[role='main']",
    "article",
    ".shopify-section"
  ];

  function queryParamDisables() {
    try {
      var params = new URLSearchParams(window.location.search);
      var value = String(params.get(config.killParam || "tk9_copy_lock") || "").toLowerCase();
      return Boolean(disabledValues[value]);
    } catch (error) {
      return false;
    }
  }

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function isEditable(target) {
    return Boolean(closest(target, editableSelector));
  }

  function eventScope(event) {
    var target = event && event.target;
    if (target && target.nodeType === 3) target = target.parentNode;
    return closest(target, scopeSelector);
  }

  function selectionTouchesScope() {
    var selection = window.getSelection && window.getSelection();
    if (!selection || selection.rangeCount === 0 || selection.isCollapsed) return false;

    for (var index = 0; index < selection.rangeCount; index += 1) {
      var range = selection.getRangeAt(index);
      var container = range.commonAncestorContainer;
      var element = container.nodeType === 1 ? container : container.parentElement;
      if (closest(element, scopeSelector)) return true;
    }

    return false;
  }

  function preventScoped(event) {
    if (!eventScope(event) || isEditable(event.target)) return;
    event.preventDefault();
  }

  function preventDrag(event) {
    if (!eventScope(event) || isEditable(event.target)) return;
    event.preventDefault();
  }

  function preventCopy(event) {
    if (isEditable(event.target)) return;
    if (!eventScope(event) && !selectionTouchesScope()) return;
    event.preventDefault();
  }

  function preventKeyboardCopy(event) {
    if (!(event.ctrlKey || event.metaKey) || event.altKey || isEditable(event.target)) return;
    var key = String(event.key || "").toLowerCase();
    if (!/^(a|c|x|s|u)$/.test(key)) return;
    if (!eventScope(event) && !selectionTouchesScope() && key !== "s" && key !== "u") return;
    event.preventDefault();
  }

  function activate() {
    if (config.enabled === false || queryParamDisables()) return;

    var selectors = Array.isArray(config.targets) && config.targets.length ? config.targets : defaultTargets;
    var roots = [];
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (node.matches && node.matches("script, style, noscript")) return;
        roots.push(node);
      });
    });

    roots.forEach(function (node) {
      node.classList.add("tk9-copy-lock-scope");
      node.setAttribute("data-tk9-copy-lock-scope", "1");
    });

    if (!roots.length) return;
    document.documentElement.setAttribute("data-tk9-copy-lock-active", "1");
    document.addEventListener("contextmenu", preventScoped, true);
    document.addEventListener("selectstart", preventScoped, true);
    document.addEventListener("dragstart", preventDrag, true);
    document.addEventListener("copy", preventCopy, true);
    document.addEventListener("cut", preventCopy, true);
    document.addEventListener("keydown", preventKeyboardCopy, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", activate, { once: true });
  } else {
    activate();
  }
})();
